import React from 'react';
import { connect } from 'react-redux';
import { Routes, Route } from 'react-router-dom';
import i18n from 'i18next';
import { Trans } from "react-i18next";
import { OwlRepository, AdmsRepository } from '../../redux/index';
import SettingsActions from '../../redux/SettingsActions';
import {AssetListView, AssetCardView, EMDCardView, XSDViewer, IEPCardView, LinkerViewer,
  ConceptSchemeListView, ConceptSchemeCardView, 
  ValuesVocabsListView, IndividualCardView, SKSAOntologyView, SubjectCardView } from '../../views/containers'
import { LoadingComponent, ErrorMessageComponent } from '../../utils/ui'
import {PromiseSequenceRunner} from '../../utils/promiseUtil'
import { factory } from '../../components/adms/Providers'
import { Modal } from 'antd';
import LinkerActions from '../../redux/LinkerActions';
import withRouter from '../../withRouter';
import { RDFDetailRoute } from '../../views/rdf/RDFDetail';

/** Окно для установки связи с выбранном элементом  */
const showViewLinker = (factory, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("syncPercent", syncPercent); 
	return <Modal style={{minWidth: "80%"}} visible={true} 
    title={i18n.t('panel.adms.link.create_title')} 
    cancelText={i18n.t('panel.adms.link.create_cancel')} okText={i18n.t('panel.adms.link.create_ok')} 
		onCancel={onCancelOperation} onOk={onFinishOperation}>
        <LinkerViewer factory={factory} />
	  </Modal>
}

//Отображение сообщения о нелицензионной копии
const LicenseWarning = () => {
  const href = i18n.t("panel.adms.licenseWarningLinkUrl");
  const company = i18n.t("panel.adms.companyName");
  return (
    <Trans
      i18nKey="panel.adms.licenseWarning"
      values={{ company }}
      components={{
        center: <div style={{ textAlign: "center" }} />,
        red: <b style={{ color: "red" }} />,
        companyLink: <a href={href} target="_blank" rel="noopener noreferrer" />
      }}
    />
  );
}
/** Панель ADMS каталога. Перед отображдением загружает:
 *  1. Онтологию ADMS-WF
 *  2. Таксономию каталога
 *  3. Параметры визуализации активов
 */
export class ADMSPanel extends React.Component {
  
  state = {
    loading: false,
    linker: undefined,    //Флаг, что должен отображаться диалог назначения связи
    error: undefined,
  }
  
  static getDerivedStateFromProps(props, state) {
    //console.log("ADMSPanel.js static getDerivedStateFromProps", props, state);
    if (props.linker && (props.linker.state=="show")){
        return { ...state, linker: true}
    } 
    if (state.linker)
      return { ...state, linker: false}
    return null; // Return null to indicate no change to state.
  }

  beforeLoadAdmsOntology() {
    return Promise.resolve();
  }

  afterUnmountAdmsPanel() {
    return Promise.resolve();
  }

  componentDidMount() {
    Promise.resolve(this.beforeLoadAdmsOntology())
    .then(() => this.loadAdmsOntology());
  }

  componentWillUnmount() {
    this.afterUnmountAdmsPanel();
  }
  
  loadAdmsOntology() {
    this.setState({loading: true})
    return PromiseSequenceRunner([ //Promise.all
      //Загрузим описание онтологии SKSA
      () => this.props.dispatch(OwlRepository.loadOntology()),
      //Обработает получение онтологии, обновив описание в провайдере
      (ontology) => {
          if (ontology) 
            factory.provider.updateOntology(ontology)
          return ontology;
        },
      //Загрузим описание каталога
      () => this.props.dispatch(AdmsRepository.loadCatalogDetails()),
      //Загрузим тексономию
      () => this.props.dispatch(AdmsRepository.loadThemeTaxonomy()),
      //Снять обязательный фильтр (если он есть)
      () => this.props.dispatch(AdmsRepository.SET_RFILTER([])),
      //Загрузим статистику таксономии
      () => this.props.dispatch(AdmsRepository.loadTaxonomyStatistic()),
      //Загрузить систему языков
      () => this.props.dispatch(SettingsActions.loadLinguisticSystem())
    ])
    .then ((response) =>{
      this.setState({loading: false, error: undefined});
    })
    .catch(e => { 
      this.setState({loading: false, error: e});
    });
  }
    
  cancelOperation(){
		this.props.dispatch(LinkerActions.EMPTY());
  }

  renderRoutes() {
    return (
      <Routes>
        <Route path="/adms/:id" element={<AssetCardView factory={factory} />}></Route>
        <Route path="/viewemd/:id" element={<EMDCardView factory={factory} />}></Route>
        <Route path="/vieweip/:id" element={<IEPCardView factory={factory} />}></Route>
        <Route path="/xsd/:id" element={<XSDViewer factory={factory} />}></Route>            
        <Route path="/skos/:id" element={<ConceptSchemeCardView factory={factory} />}></Route>            
        <Route path="/schemes" element={<ConceptSchemeListView factory={factory} />}></Route>            
        <Route path="/sksaowl" element={<SKSAOntologyView factory={factory} />}></Route>
        <Route path="/sksaowl/:id" element={<SKSAOntologyView factory={factory} />}></Route>
        <Route path="/catalog/:id/*" element={<AssetListView factory={factory} />}></Route>
        <Route path="/vocabs" element={<ValuesVocabsListView factory={factory} />}></Route>
        <Route path="/individual/:id" element={<IndividualCardView factory={factory} />}></Route>              
        <Route path="/ttl/*" element={<RDFDetailRoute />}></Route>
        <Route path="/subject/:id" element={<SubjectCardView factory={factory} />}></Route>
        <Route path="/subject/*" element={<SubjectCardView factory={factory} />}></Route>
        <Route path="*" element={<AssetListView factory={factory}  />}></Route>
      </Routes>
    )
  }

  render() {
    console.log(this);
    const { loading, linker } = this.state;
    const { pch } = this.props ;
    return (
        (loading? 
          <LoadingComponent />:
          <span>
            {!pch && <LicenseWarning /> }                        
            {this.renderRoutes()}            
            {linker && showViewLinker(
              factory, 
              ()=>this.cancelOperation(), 
              ()=>this.cancelOperation())
            }
          </span>
        )
    );
  }
}
  
function mapStateToProps(state, props) {
  //console.log("ADMSPanel.js function mapStateToProps(state, props)", state, props);
  const { vset, linker } = state;
  const { graph, lang } = props;
  return {
    graph: (graph)?graph: vset.graph,
    pch: vset.pch && (vset.pch.toLowerCase() === "yes" || vset.pch.toLowerCase()==="default"),
    lang: (lang)?lang: vset.lang,
    linker
  };
}

export default withRouter(connect(mapStateToProps)(ADMSPanel));
